import HSC2 from '../components/HSC2';
import { model, fblink } from '../config/config';
import Slider from '../components/Slider';




function Home() {
	//localStorage['model'] = "gtr4";
	console.log("home model "+localStorage['model']);
	
	if(!localStorage.getItem('model')) {
		localStorage['model'] = 'gtr4';
	}else{
		console.log("home model "+localStorage['model']);
	}
	
	const newTabs = [
    {
      name: 'New',
      api: `${fblink}/watches.json?orderBy="category"&startAt="Amazfit New Watch"&endAt="Amazfit New Watch"`,
    },
    {
      name: 'Old',
      api: `${fblink}/watchface/${model}.json?orderBy="$key"&limitToFirst=11`
    }
  ];
  
  const trendingTabs = [
    {
      name: 'New',
      api: `${fblink}/watches.json?orderBy="category"&startAt="Amazfit GTR"&endAt="Amazfit GTR"`,
    },
    {
      name: 'Old',
      api: `${fblink}/watchface/${model}.json?orderBy="$key"&limitToFirst=11`
    }
  ];

  const popularTabs = [
    {
      name: 'New',
      api: `${fblink}/watches.json?orderBy="category"&startAt="Amazfit GTS"&endAt="Amazfit GTS"`,
      binfile: 'movie'
    },
    {
      name: 'Old',
      api: `${fblink}/watchface/${model}.json?orderBy="$key"&limitToFirst=11`,
      binfile: 'tv'
    }
  ];
  const topRatedTabs = [
    {
      name: 'New',
      api: `${fblink}/watches.json?orderBy="category"&startAt="Amazfit Bip"&endAt="Amazfit Bip"`,
      binfile: 'movie'
    },
    {
      name: 'Old',
      api: `${fblink}/watchface/${model}.json?orderBy="$key"&limitToFirst=11`,
      binfile: 'tv'
    }
  ];
  const trexTabs = [
    {
      name: 'New',
      api: `${fblink}/watches.json?orderBy="category"&startAt="Amazfit T-Rex"&endAt="Amazfit T-Rex"`,
      binfile: 'movie'
    },
    {
      name: 'Old',
      api: `${fblink}/watchface/${model}.json?orderBy="$key"&limitToFirst=11`,
      binfile: 'tv'
    }
  ];
  const otherTabs = [
    {
      name: 'New',
      api: `${fblink}/watches.json?orderBy="category"&startAt="Amazfit Other"&endAt="Amazfit Other"`,
      binfile: 'movie'
    },
    {
      name: 'Old',
      api: `${fblink}/watchface/${model}.json?orderBy="$key"&limitToFirst=11`,
      binfile: 'tv'
    }
  ];
  const mibandTabs = [
    {
      name: 'New',
      api: `${fblink}/watches.json?orderBy="category"&startAt="Mi Band"&endAt="Mi Band"`,
      binfile: 'movie'
    },
    {
      name: 'Old',
      api: `${fblink}/watchface/${model}.json?orderBy="$key"&limitToFirst=11`,
      binfile: 'tv'
    }
  ];

  return (
    <div>
      <Slider />
      <div style={{ padding: "64px 1vw 64px 1vw" }}>
	   <HSC2 name="Amazfit New Series" tabs={newTabs}/>
        <HSC2 name="Amazfit GTR Series" tabs={trendingTabs}/>
        <HSC2 name="Amazfit GTS Series" tabs={popularTabs}/>
        <HSC2 name="Amazfit Bip Series" tabs={topRatedTabs}/>
		<HSC2 name="Amazfit T-Rex Series" tabs={trexTabs}/>
		<HSC2 name="Amazfit Other Watches" tabs={otherTabs}/>
		<HSC2 name="Xiaomi Mi Band Series" tabs={mibandTabs}/>
      </div>
    </div>
  );
}
export default Home;